import { render, staticRenderFns } from "./buscador-instituciones-snp.vue?vue&type=template&id=55c62196&scoped=true&"
import script from "./buscador-instituciones-snp.component.ts?vue&type=script&lang=ts&"
export * from "./buscador-instituciones-snp.component.ts?vue&type=script&lang=ts&"
import style0 from "./buscador-instituciones-snp.vue?vue&type=style&index=0&id=55c62196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c62196",
  null
  
)

export default component.exports